<div class="mgn-bottom-15 rate-component">
        <label *ngFor="let e of arrayRating" class="rate-label" [title]="e">
            <input type="radio" [formControl]="control" [id]="id + e" [name]="id" [value]="+e" /> <span class="ratemark"
                [ngClass]="{'fill-radiomark fill-ratemark':control.value>=(+e)}"></span>

            {{+e}}
        </label>
</div>